import { Directive,ElementRef,HostListener,Input,Renderer2,OnInit,OnDestroy } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Directive({
  selector: '[delayedRenderer]'
})
export class DelayedRendererDirective implements OnInit, OnDestroy {

  private _delay:number;

  @Input() set delayedRenderer(value: number ) {
    this._delay = value;
  }

  @Input() set data(value: any ) {
    value.displayed = false;
    this.creatTimeout(this._delay*10,value);
  }
  constructor(
      private el: ElementRef,private renderer: Renderer2,
      private logger:NGXLogger ) {
  }

  ngOnInit(): void {

    // const child = document.createElement('div');
    // this.renderer.appendChild(this.elementRef.nativeElement, child);
    const child = this.renderer
  }

  private creatTimeout(value: number, data:any ): void {
    var tmpData = data;
    setTimeout(val => tmpData.displayed = true,value);
  }

  ngOnDestroy(): void {

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/directives/delayed-renderer.directive.ts